<template>
    <div>
        <div class="form-group col-12">
            <label for="stars">Stars</label>
            <input
                id="stars"
                v-model="tier.stars"
                type="number"
                min="1"
                class="form-control"
                :class="{
                    'is-invalid': hasError('stars')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('stars') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            tier: {}
        };
    },

    watch: {
        tier() {
            this.$emit('input', this.tier);
        }
    },

    created() {
        this.tier = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.tier[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.tier,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
